<div class="indicator-container" #indicator>
    <div class="color-picker-wrapper">
        <input disabled class="color-input" [cpToggle]="" [(colorPicker)]="color" [style.background]="color" />
    </div>

    <div class="color-text-container">
        <h6 class="color-name">
            {{ statusString | translate }}
        </h6>
        <span class="color-text">
            {{ this.rgb + ', ' + this.alpha + '%' }}
        </span>
    </div>
</div>
